/* eslint-disable */
import axios from 'axios'
import qs from 'qs'

const apiAssetCategoriesSubPath = (assetId = "") => `api/AssetCategories/${assetId}`
const apiAssetManufacturersSubPath = (assetManufacturerId = "") => `api/AssetManufacturers/${assetManufacturerId}`
const apiAssetModelsSubPath = (assetModelsId = "") => `api/AssetModels/${assetModelsId}`
const apiAssetPropertiesSubPath = (assetPropertyId = "") => `api/AssetProperties/${assetPropertyId}`
const apiClientsSubPath = (clientId = "") => `api/Clients/${clientId}`
const apiUsersSubPath = (userId = "") => `api/Users/${userId}`
const apiFetchSubPath = () => `api/Fetch`
const apiLocationsSubPath = (locationId = "") => `api/Locations/${locationId}`
const apiAssetsSubPath = (assetId = "") => `api/Assets/${assetId}`
const apiAssetsExcelSubPath = `api/Assets/Excel`
const apiActivityTypesSubPath = (activityTypeId = "") => `api/ActivityTypes/${activityTypeId}`
const apiActivitiesSubPath = (activityId = "") => `api/Activities/${activityId}`
const apiActivityDeleteAttachmentSubPath = (activityId, attachmentId) => `api/Activities/${activityId}/Attachments/${attachmentId}`
const apiAssetStatusesSubPath = (assetStatusId = "") => `api/AssetStatuses/${assetStatusId}`
const apiAttachmentsSubPath = (attachmentId = "") => `api/Attachments/${attachmentId}`
const apiSourcesSubPath = () => `api/Sources/`

const pluginServiceLink = 'equipment_tracker'

import {
  createNamespacedHelpers,
} from 'vuex'

const plugin = createNamespacedHelpers('plugin')
export default {
  computed: {
    ...plugin.mapGetters(['activePluginByServiceLink']),
    plugin() {
      return this.activePluginByServiceLink(pluginServiceLink)
    }
  },
  methods: {
    _fetchAssetDetail({
      assetId,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetsSubPath(assetId)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .get(url)
        .then(
          res => {
            res.data.dateTimeStatusLastUpdated = new Date(res.data.dateTimeEpochStatusLastUpdated)
            res.data.dateTimeLocationLastUpdated = new Date(res.data.dateTimeEpochLocationLastUpdated)
            res.data.dateTimeActivityLastPerformed = new Date(res.data.dateTimeEpochActivityLastPerformed)
            res.data.attachmentList.forEach(attachment => {
              attachment.dateTimeUploaded = new Date(attachment.dateTimeEpochUploaded)
              if (attachment.activityList && attachment.activityList.length) {
                attachment.activityList.forEach(activity => {
                  activity.dateTimePerformedOn = new Date(activity.dateTimeEpochPerformedOn)
                });
              }
            });
            res.data.activityList.forEach(activity => {
              activity.dateTimePerformedOn = new Date(activity.dateTimeEpochPerformedOn)
            });
            successCb(res.data)
          },
          error => failedCb(error.response)
        )
    },
    _fetchActivityDetail({
      activityId,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiActivitiesSubPath(activityId)
      let url = this.plugin.service.proxyUrlMaker(subpath)
      axios
        .get(url)
        .then(
          res => {
            if (res.data) {
              if (res.data.assetList && res.data.assetList.length) {
                res.data.assetList.forEach(asset => {
                  asset.dateTimeStatusLastUpdated = new Date(asset.dateTimeEpochStatusLastUpdated)
                  asset.dateTimeLocationLastUpdated = new Date(asset.dateTimeEpochLocationLastUpdated)
                  asset.dateTimeActivityLastPerformed = new Date(asset.dateTimeEpochActivityLastPerformed)
                });
              }
              if (res.data.attachmentList && res.data.attachmentList.length) {
                res.data.attachmentList.forEach(attachment => {
                  attachment.dateTimeUploaded = new Date(attachment.dateTimeEpochUploaded)
                });
              }
              res.data.dateTimePerformedOn = new Date(res.data.dateTimeEpochPerformedOn)
            }
            successCb(res.data)
          },
          error => failedCb(error.response)
        )
    },
    _fetchAttachmentDetail({
      attachmentId,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAttachmentsSubPath(attachmentId)
      let url = this.plugin.service.proxyUrlMaker(subpath)
      axios
        .get(url)
        .then(
          res => {
            if (res.data) {
              res.data.dateTimeUploaded = new Date(res.data.dateTimeEpochUploaded)
              if (res.data.assetList && res.data.assetList.length) {
                res.data.assetList.forEach(asset => {
                  asset.dateTimeStatusLastUpdated = new Date(asset.dateTimeEpochStatusLastUpdated)
                  asset.dateTimeLocationLastUpdated = new Date(asset.dateTimeEpochLocationLastUpdated)
                  asset.dateTimeActivityLastPerformed = new Date(asset.dateTimeEpochActivityLastPerformed)
                });
              }
              if (res.data.activityList && res.data.activityList.length) {
                res.data.activityList.forEach(activity => {
                  activity.dateTimePerformedOn = new Date(activity.dateTimeEpochPerformedOn)
                });
              }
            }
            successCb(res.data)
          },
          error => failedCb(error.response)
        )
    },
    _fetchAttachmentFile({
      attachmentId,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAttachmentsSubPath(attachmentId) + '/file'
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .get(url, {
          responseType: 'blob'
        })
        .then(
          res => {
            const type = res.headers['content-type']
            const blob = new Blob([res.data], {
              type: type,
              encoding: 'UTF-8'
            })
            successCb(blob)
          },
          error => failedCb(error.response)
        )
    },
    async _fetchAssetList({
      pageNum,
      pageSize,
      searchText,
      statusIds,
      activityTypeIds,
      modelIds,
      categoryIds,
      locationIds,
      ownerIds,
      manufacturerIds,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetsSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      let params = {
        pageNumber: pageNum || 1,
        pageSize,
        searchText,
        statusIds,
        activityTypeIds,
        modelIds,
        categoryIds,
        locationIds,
        ownerIds,
        manufacturerIds,
      }

      try {
        let res = await axios.get(url, {
          params,
          paramsSerializer: params => {
            return qs.stringify(params, { skipNulls: true })
          }
        })

        res.data.assetList.forEach(asset => {
          asset.dateTimeActivityLastPerformed = new Date(asset.dateTimeEpochActivityLastPerformed)
          asset.dateTimeStatusLastUpdated = new Date(asset.dateTimeEpochStatusLastUpdated)
          asset.dateTimeLocationLastUpdated = new Date(asset.dateTimeEpochLocationLastUpdated)
        });

        successCb(res.data)
      } catch (error) {
        failedCb(error.response)
      }
    },
    async _fetchAssetListExcel({
      searchText,
      statusIds,
      activityTypeIds,
      modelIds,
      categoryIds,
      locationIds,
      ownerIds,
      manufacturerIds,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetsExcelSubPath
      let url = this.plugin.service.proxyUrlMaker(subpath)

      let params = {
        searchText,
        statusIds,
        activityTypeIds,
        modelIds,
        categoryIds,
        locationIds,
        ownerIds,
        manufacturerIds,
      }

      try {
        let res = await axios.get(url, {
          responseType: 'blob',
          params,
          paramsSerializer: params => {
            return qs.stringify(params, { skipNulls: true })
          }
        })

        const type = res.headers['content-type']
        const blob = new Blob([res.data], { type: type, encoding: 'UTF-8' })
        successCb(blob)
      } catch (error) {
        failedCb(error.response)
      }
    },
    async _fetch({
      types,
      isEnabled,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiFetchSubPath();
      let url = this.plugin.service.proxyUrlMaker(subpath)

      let params = {
        type: types,
        isEnabled,
      }

      axios
        .get(url, {
          params,
          paramsSerializer: params => {
            return qs.stringify(params, { skipNulls: true })
          }
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _fetchPropertyKeyList({
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetPropertiesSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .get(url + 'Keys')
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _insertCategory({
      name,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetCategoriesSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .post(url, {
          name: name
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateCategory({
      id,
      name,
      isEnabled,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetCategoriesSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          name: name,
          isEnabled: isEnabled,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _insertManufacturer({
      name,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetManufacturersSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .post(url, {
          name: name,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateManufacturer({
      id,
      name,
      isEnabled,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetManufacturersSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          name: name,
          isEnabled: isEnabled
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _insertModel({
      name,
      categoryId,
      manufacturerId,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetModelsSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .post(url, {
          name: name,
          categoryId: categoryId,
          manufacturerId: manufacturerId,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateModel({
      id,
      name,
      categoryId,
      manufacturerId,
      isEnabled,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetModelsSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          name: name,
          categoryId: categoryId,
          manufacturerId: manufacturerId,
          isEnabled: isEnabled,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _insertLocation({
      name,
      clientId,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiLocationsSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .post(url, {
          name: name,
          clientId: clientId
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateLocation({
      id,
      name,
      clientId,
      isEnabled,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiLocationsSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          name: name,
          clientId: clientId,
          isEnabled: isEnabled,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _insertActivityType({
      name,
      assetStatusIds,
      isUpcoming,
      isStatusChange,
      isLocationChange,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiActivityTypesSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .post(url, {
          name: name,
          assetStatusIds: assetStatusIds,
          isStatusChange: isStatusChange,
          isLocationChange: isLocationChange,
          isUpcoming: isUpcoming,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateActivityType({
      id,
      name,
      assetStatusIds,
      isUpcoming,
      isStatusChange,
      isLocationChange,
      isEnabled,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiActivityTypesSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          name: name,
          assetStatusIds: assetStatusIds,
          isUpcoming: isUpcoming,
          isStatusChange: isStatusChange,
          isLocationChange: isLocationChange,
          isEnabled: isEnabled,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _insertAssetStatus({
      name,
      isIdle,
      activityTypeIds,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetStatusesSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .post(url, {
          name: name,
          isIdle: isIdle,
          activityTypeIds: activityTypeIds,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateAssetStatus({
      id,
      name,
      isIdle,
      activityTypeIds,
      isEnabled,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetStatusesSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          name: name,
          isIdle: isIdle,
          activityTypeIds: activityTypeIds,
          isEnabled: isEnabled,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _insertAsset({
      names,
      locationId,
      clientId,
      modelId,
      comments,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetsSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .post(url, {
          names: names,
          locationId: locationId,
          clientId: clientId,
          modelId: modelId,
          comments: comments,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateAsset({
      id,
      name,
      clientId,
      modelId,
      comments,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetsSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          name: name,
          clientId: clientId,
          modelId: modelId,
          comments: comments,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _insertActivity({
      assetIds,
      typeId,
      statusId,
      dateTimeEpochPerformedOn,
      userIdPerformedBy,
      locationId,
      files,
      comments,
      successCb,
      failedCb,
    } = {}) {
      if (files && files.length) {
        let formData = new FormData();
        for (var i = 0; i < files.length; i++) {
          formData.append('files', files[i]);
        }
        let subpath = apiAttachmentsSubPath()
        let url = this.plugin.service.proxyUrlMaker(subpath)

        axios
          .post(url,
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            },
          ).then(
            res => {
              const attachments = []
              for (var fileIndex = 0; fileIndex < files.length; fileIndex++) {
                attachments.push({
                  id: res.data[fileIndex].id,
                  comments: files[fileIndex].comments,
                  isEnabled: true,
                })
              }

              let subpath = apiActivitiesSubPath()
              let url = this.plugin.service.proxyUrlMaker(subpath)

              axios
                .post(url, {
                  assetIds: assetIds,
                  typeId: typeId,
                  statusId: statusId,
                  dateTimeEpochPerformedOn: dateTimeEpochPerformedOn,
                  userIdPerformedBy: userIdPerformedBy,
                  locationId: locationId,
                  attachmentsToAdd: attachments,
                  comments: comments,
                })
                .then(
                  res => successCb(res.data),
                  error => failedCb(error.response)
                )
            },
            error => failedCb(error.response)
          )
      } else {
        let subpath = apiActivitiesSubPath()
        let url = this.plugin.service.proxyUrlMaker(subpath)

        axios
          .post(url, {
            assetIds: assetIds,
            typeId: typeId,
            statusId: statusId,
            dateTimeEpochPerformedOn: dateTimeEpochPerformedOn,
            userIdPerformedBy: userIdPerformedBy,
            locationId: locationId,
            attachmentsToAdd: [],
            comments: comments,
          })
          .then(
            res => successCb(res.data),
            error => failedCb(error.response)
          )
      }
    },
    _updateActivity({
      id,
      typeId,
      dateTimeEpochPerformedOn,
      userIdPerformedBy,
      locationId,
      statusId,
      comments,
      files,
      successCb,
      failedCb,
    } = {}) {
      if (files && files.length) {
        let formData = new FormData();
        for (var i = 0; i < files.length; i++) {
          formData.append('files', files[i]);
        }

        let subpath = apiAttachmentsSubPath()
        let url = this.plugin.service.proxyUrlMaker(subpath)

        axios
          .post(url,
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            },
          ).then(
            res => {
              const attachments = []
              for (var fileIndex = 0; fileIndex < files.length; fileIndex++) {
                attachments.push({
                  id: res.data[fileIndex].id,
                  comments: files[fileIndex].comments,
                  isEnabled: true,
                })
              }

              let subpath = apiActivitiesSubPath(id)
              let url = this.plugin.service.proxyUrlMaker(subpath)

              axios
                .put(url, {
                  id: id,
                  typeId: typeId,
                  dateTimeEpochPerformedOn: dateTimeEpochPerformedOn,
                  userIdPerformedBy: userIdPerformedBy,
                  locationId: locationId,
                  attachmentsToAdd: attachments,
                  statusId: statusId,
                  comments: comments,
                })
                .then(
                  res => successCb(res.data),
                  error => failedCb(error.response)
                )
            },
            error => failedCb(error.response)
          )
      } else {
        let subpath = apiActivitiesSubPath(id)
        let url = this.plugin.service.proxyUrlMaker(subpath)

        axios
          .put(url, {
            id: id,
            typeId: typeId,
            dateTimeEpochPerformedOn: dateTimeEpochPerformedOn,
            userIdPerformedBy: userIdPerformedBy,
            locationId: locationId,
            attachmentsToAdd: [],
            statusId: statusId,
            comments: comments,
          })
          .then(
            res => successCb(res.data),
            error => failedCb(error.response)
          )
      }
    },
    _insertProperty({
      assetId,
      key,
      value,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetPropertiesSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .post(url, {
          assetId: assetId,
          key: '' + key,
          value: '' + value,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateProperty({
      id,
      key,
      value,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetPropertiesSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)
      axios
        .put(url, {
          id: id,
          key: key,
          value: value,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _deleteProperty({
      id,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAssetPropertiesSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .delete(url)
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _insertClient({
      name,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiClientsSubPath()
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .post(url, {
          name: name,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateClient({
      id,
      name,
      isEnabled,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiClientsSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          name: name,
          isEnabled: isEnabled
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateAttachment({
      id,
      comments,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiAttachmentsSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          comments: comments,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _deleteActivityAttachmentLink({
      activityId,
      attachmentId,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiActivityDeleteAttachmentSubPath(activityId, attachmentId)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .delete(url)
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
    _updateUser({
      id,
      isEnabled,
      successCb,
      failedCb,
    } = {}) {
      let subpath = apiUsersSubPath(id)
      let url = this.plugin.service.proxyUrlMaker(subpath)

      axios
        .put(url, {
          id: id,
          isEnabled: isEnabled,
        })
        .then(
          res => successCb(res.data),
          error => failedCb(error.response)
        )
    },
  },
}